import React from "react";
import FullScreen from '../components/UI/FullScreen';
import LoginForm from "../components/login/LoginForm";
import NotflixLogo from "../components/UI/NotflixLogo";

const Login = () => {
    return (
        <FullScreen>
            <NotflixLogo />
            <LoginForm></LoginForm>
            <div style={{marginTop: 20}}>
                <p style={{marginBottom: 10, color: '#666'}}>Enter any username and password</p>
                <p style={{marginBottom: 10, color: '#666'}}>This is not real and the data is not stored anywhere</p>
            </div>
        </FullScreen>
    )
}

export default Login;
